import React from 'react';

const PageHero = ({ eyebrow, title, subtitle, accent = 'text-[#FF5B24]', children }) => (
  <section className="relative overflow-hidden bg-gradient-to-b from-[#FAF6F2] via-white to-white pt-16 pb-20">
    <div className="absolute -top-24 -left-24 w-[420px] h-[420px] bg-[#FF5B24]/20 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute -top-12 right-0 w-[380px] h-[380px] bg-indigo-300/20 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#FF5B24]">
        <span className="w-1.5 h-1.5 rounded-full bg-[#FF5B24]" /> {eyebrow}
      </div>
      <h1 className="mt-4 text-4xl md:text-6xl font-extrabold text-[#0a0e27] leading-[1.05]">
        {title.split('|').map((part, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className={accent}>{part}</span>}
            {i === 0 && part}
          </React.Fragment>
        ))}
      </h1>
      {subtitle && <p className="mt-6 text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>}
      {children && <div className="mt-8">{children}</div>}
    </div>
  </section>
);

export default PageHero;
